module.exports = __webpack_public_path__ + "static/media/IWCF.eccf72b1.png";